import {Component, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-specProb-detail',
  templateUrl: './specProb-detail.component.html'
})
export class SpecProbDetailComponent extends BaseComponent {
  specProb:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/domain/specProbs/${id}`).subscribe(
            data => {
              this.specProb = data as any;
            }
          );
        }
      });
  }

  createNew() {
    this.specProb = {
      value: ''
    };
  }

  save() {
    if (!this.specProb.id) {
      this.http.post(`${this.env.e.url}/domain/specProbs`, this.specProb)
        .subscribe(
          data => {
            this.specProb = data;
            this.alertService.info(`Created ${this.specProb.value}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/domain/specProbs/${this.specProb.id}`, this.specProb)
        .subscribe(
          data => {
            this.specProb = data;
            this.alertService.info(`Updated Settings`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/domain/specProbs/${this.specProb.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.specProb.value}`);
          this.router.navigate(["/specProbs"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
